import { render } from "./UserItem.vue?vue&type=template&id=b14ea21c"
import script from "./UserItem.vue?vue&type=script&lang=js"
export * from "./UserItem.vue?vue&type=script&lang=js"
script.render = render

export default script